import Vue from 'vue'
import Router from 'vue-router'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(Element);

const Login = () => import('@/components/index');
const Logins = () => import('@/components/Login.vue');
const AdminLogin = () => import('@/components/adminLogin/AdminLogin.vue');
const Home = () => import('@/components/home/Home.vue');
// import Logins from '@/components/Login.vue'
// import AdminLogin from '@/components/adminLogin/AdminLogin.vue'
// import Home from '@/components/home/Home.vue'
// import About from '@/components/home/About.vue'
// import Product from '@/components/home/Product.vue'
const Smartscreen = () => import('@/components/Smartscreen.vue');
// const Screen = () => import('@/pages/bigData/Screen.vue');
const shouJi = () => import('@/pages/workbench/shouji/StandalonePage.vue');

//界面
// const organization  = () => import('@/components/organization.vue');

Vue.use(Router)

export default new Router({
  mode: 'hash', //去掉链接的#号
  // base: 'yusun', //去掉链接的/杠
  // 路由的懒加载
  routes: [
    {// 重定向
      path: '/',
      redirect: '/logins'        // /logins     //  /adminLogin  //home
    },
    {
      path: '/index',
      redirect: '/index/staging',
      name: 'index',
      component: Login,
      meta: {isAuth: true},
      //独享前置路由守卫
      beforeEnter: (to, form, next) => {
        if (localStorage.getItem("USERDATA")) {
          next();
        } else {
          next(false);
        }
      },
      children: [
        {
          path: 'staging',
          name: 'staging',
          component: () => import('@/components/staging/Staging.vue')
        },
        {
          path: 'organization',
          name: 'organization',
          component: () => import('@/components/organization.vue')
        },
        {
          path: 'role',
          name: 'role',
          component: () => import('@/components/role.vue')
        },
        {
          path: 'user',
          name: 'user',
          component: () => import('@/components/user.vue')
        },
        {
          path: 'class',
          name: 'class',
          component: () => import('@/components/ClassAdmini.vue')
        },
        {
          path: 'student',
          name: 'student',
          component: () => import('@/components/Student.vue')
        },
        {
          path: 'business',
          name: 'business',
          component: () => import('@/components/TripartitePost.vue'),
          props: {isShow: false}
        },
        {
          path: 'position',
          name: 'position',
          component: () => import('@/components/TripartitePost.vue'),
          props: {isShow: true}
        },
      
        {
          path: 'teacherReport',
          name: 'teacherReport',
          component: () => import('@/pages/teacherReport/teacherReport.vue')
        },
        {
          path: 'modifyRecord',
          name: 'modifyRecord',
          component: () => import('@/pages/modifyRecord/modifyRecord.vue')
        },
        {
          path: 'askfor',
          name: 'askfor',
          component: () => import('@/pages/internship/askFor.vue')
        },
     
        {
          path: 'mystudents',
          name: 'mystudents',
          component: () => import('@/pages/workbench/iStudent/IStudent.vue')
        },
        {
          path: 'change',
          name: 'change',
          component: () => import('@/pages/StudyManagement/internshipChange/internshipChange.vue')
        },
        {
          path: 'clockin',
          name: 'clockin',
          component: () => import('@/pages/StudyManagement/Clockin/Clockin.vue')
        },
        {
          path: 'clockin2',
          name: 'clockin2',
          component: () => import('@/pages/StudyManagement/Clockin/Clockin2.vue')
        },
        {
          path: 'askforleave',
          name: 'askforleave',
          component: () => import('@/pages/StudyManagement/askforleave/Askforleave.vue')
        },
        {
          path: 'report',
          name: 'report',
          component: () => import('@/pages/StudyManagement/report/report.vue')
        },
        {
          path: 'report2',
          name: 'report2',
          component: () => import('@/pages/StudyManagement/report/report2.vue')
        },
        {
          path: 'guidance',
          name: 'guidance',
          component: () => import('@/pages/Patrol/guidance/Guidance.vue')
        },
        {
          path: 'Patrol',
          name: 'Patrol',
          component: () => import('@/pages/Patrol/patrol/Patrol.vue')
        },
        {
          path: 'storeup',
          name: 'storeup',
          component: () => import('@/pages/StudyManagement/storeup/Storeup.vue')
        },
        {
          path: 'setup',
          name: 'setup',
          component: () => import('@/pages/assess/setUp/SetUp.vue')
        },
        {
          path: 'result',
          name: 'result',
          component: () => import('@/pages/assess/result/Result.vue')
        },
        {
          path: 'Check',
          name: 'Check',
          component: () => import('@/pages/assess/check/Check.vue')
        },
        {
          path: 'summary',
          name: 'summary',
          component: () => import('@/pages/StudyManagement/summary/Summary.vue')
        },
        {
          path: 'safety',
          name: 'safety',
          component: () => import('@/pages/safety/safety/Safety.vue')
        },
        {
          path: 'unusual',
          name: 'unusual',
          component: () => import('@/pages/safety/unusual/Unusual.vue')
        },
        {
          path: 'unusualrecord',
          name: 'unusualrecord',
          component: () => import('@/pages/safety/unusualRecord/UnusualRecord.vue')
        },
        {
          path: 'safeinfo',
          name: 'safeinfo',
          component: () => import('@/pages/safety/safeinfo/SafeInfo.vue')
        },
        {
          path: 'test',
          name: 'test',
          component: () => import('@/pages/safety/kaoshi/kaoshi.vue')
        },
        {
          path: 'testscores',
          name: 'testscores',
          component: () => import('@/pages/safety/tesScores/TestScores.vue')
        },
        {
          path: 'archivesrelease',
          name: 'archivesrelease',
          component: () => import('@/pages/archives/archivesWrite/ArchivesWrite.vue')
        },
        {
          path: 'archives',
          name: 'archives',
          component: () => import('@/pages/archives/Archives.vue')
        },
        {
          path: 'sign',
          name: 'sign',
          component: () => import('@/pages/analysis/sign/Sign.vue')
        },
        {
          path: 'weeklydaily',
          name: 'weeklydaily',
          component: () => import('@/pages/analysis/weeklyDaily/WeeklyDaily.vue')
        },
        {
          path: 'active',
          name: 'active',
          component: () => import('@/pages/analysis/active/Active.vue')
        },
        {
          path: 'process',
          name: 'process',
          component: () => import('@/pages/analysis/process/Process.vue')
        },
        {
          path: 'area',
          name: 'area',
          component: () => import('@/pages/dataAnalysis/Area.vue')
        },
        {
          path: 'field',
          name: 'field',
          component: () => import('@/pages/dataAnalysis/Field.vue')
        },
        {
          path: 'timelength',
          name: 'timelength',
          component: () => import('@/pages/dataAnalysis/TimeLength.vue')
        },
        {
          path: 'posts',
          name: 'posts',
          component: () => import('@/pages/info/posts/Posts.vue')
        },
        {
          path: 'schooltube',
          name: 'schooltube',
          component: () => import('@/components/schoolTube/schoolTube.vue')
        },
        {
          path: 'grade',
          name: 'grade',
          component: () => import('@/components/schoolTube/addGrade/AddGrade.vue')
        },
        {
          path: 'schoolgradevip',
          name: 'schoolgradevip',
          component: () => import('@/components/schoolTube/gradeVip/GradeVip.vue')
        },
        {
          path: 'collocation',
          name: 'collocation',
          component: () => import('@/components/schoolTube/collocation.vue')
        },
        {
          path: 'schoolapply',
          name: 'schoolapply',
          component: () => import('@/components/schoolTube/schoolApply/SchoolApply.vue')
        },
        {
          path: 'feedback',
          name: 'feedback',
          component: () => import('@/components/schoolTube/feedback/Feedback.vue')
        },
        {
          path: 'testpage',
          name: 'testpage',
          component: () => import('@/components/schoolTube/testPage/TestPage.vue')
        },
        {
          path: 'manager',
          name: 'manager',
          component: () => import('@/pages/archives/archivesWrite/Manager.vue')
        },
        {
          path: 'internship',
          name: 'Internship',
          component: () => import('@/pages/archives/InternshipTracker.vue')
        },
        {
          path: '*',
          redirect: '/index/staging'
        }
      ],
    },
    {
      path: '/logins',
      name: 'logins',
      component: Logins
    },
    {
      path: '/adminLogin',
      name: 'adminLogin',
      component: AdminLogin
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/Smartscreen',
      meta: {isAuth: false},
      name: 'Smartscreen',
      component: Smartscreen
    },
    {
      path: '/shouJi',
      name: 'shouJi',
      component: shouJi
    },
    {
      path: '/123',
      name: '123',
      component: () => import('@/pages/workbench/handleOne/123.vue')
    },
    {
      path: '/testpage',
      name: 'testpage',
      component: () => import('@/components/schoolTube/testPage/TestPage.vue')
    },
    // {
    //    path: '/screen',
    //    meta:{isAuth:false},
    //    name: 'Screen',
    //    component: Screen
    // }
  ],
})




// WEBPACK FOOTER //
// ./src/router/index.js